// @flow

import { isSearchResultsPath } from '@seek/seek-jobs-seo';
import { getSolWrapper } from './';
import { getMetadataFor } from './utils/getMetadataFor';
import { getElementMetadataPairs } from './utils/getElementMetadataPairs';
import { addJobDetailsMetadata } from './utils/solJobMetadataStore';
import { addTags } from './utils/addTags';

const attachSearchResultsMonitors = (sol, searchResultsMetadataPairs) => {
  searchResultsMetadataPairs.forEach(({ element, solMetadata }) => {
    const tag = { 'seek:source': 'attachSearchResultsMonitors' };

    sol.monitorSearchImpression(element, addTags(solMetadata, tag));
  });
};

const trackSerpLoaded = ({ pathname }: { pathname: string }): void => {
  if (isSearchResultsPath(pathname)) {
    const sol = getSolWrapper();
    const searchMetadata = getMetadataFor('data-search-sol-meta');
    const tag = {
      'seek:source': 'trackSerpLoaded'
    };

    sol.trackSearchEvent(addTags(searchMetadata, tag));

    const searchResultsMetadataPairs = getElementMetadataPairs('data-sol-meta');
    addJobDetailsMetadata(
      searchResultsMetadataPairs.map(({ solMetadata }) => ({ solMetadata }))
    );

    attachSearchResultsMonitors(sol, searchResultsMetadataPairs);
  }
};
export default trackSerpLoaded;
